import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'ml-yes-no-icon',
  templateUrl: './yes-no-icon.component.html',
  styleUrls: ['./yes-no-icon.component.scss'],
  imports: [FaIconComponent],
})
export class YesNoIconComponent {
  @Input() flag: boolean;
  @Input() yes = 'check';
  @Input() no = 'times';
}
